





































import { Component, Vue, Mixins } from 'vue-property-decorator';
import VueHoduCommon from "@/mixin/VueHoduCommon";

@Component({
   components: {

   }
}) export default class WareHedaer extends Mixins(VueHoduCommon) {

    mounted() : void {
        $(".burger a").click(function(){
            $("#app").toggleClass("navOn");
            return false;
        });
        $(".ware_navDiv").click(function(){
            $("#app").removeClass("navOn");
            
        });
        $(".ware_nav > .noClick").click(function(){
            $(this).toggleClass("open");
            return false;
        });
    }

    /**
     * 홈으로 이동
     */
    goHome() : void {
        this.$router.push('/').catch(e => {});
        window.scrollTo(0, 0);
    }

    /**
     * 인트로 페이지로 이동
     */
    goIntro() : void {
        
        this.$router.push('/intro').catch(e => {});
        
        // this.$nextTick(() => {
        //     location.hash = `#intro`;
            
        //     // 스크롤이 맨 끝에 있는지 확인
        //     let bottomOfWindow : boolean = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight;
            
        //     // 스크롤이 끝나지 않았다면 헤더 높이인 70만큼 뺀다
        //     if( !bottomOfWindow ){
        //         window.scrollTo(0, window.pageYOffset - 70);
        //     }
        // });
    }

    /**
     * 홈으로 이동
     */
    goApp(): void {
        // if( new RegExp(/localhost/).test(location.hostname) == true || new RegExp(/192\.168\.192\.{3}/).test(location.hostname) == true ) {
            // location.href = 'https://app.hoduware.com';
            // return;
        // }

        // hodu.app
        // if( new RegExp(/hodu\.app/).test(location.hostname) ) {
            // location.href = 'https://web.hodu.app';
            // return;
        // }

        // location.href = `https://app.${location.hostname.replace(/www\./ig, "")}`;
        location.href = 'https://web.hodu.app';
    }
    
    /**
     * 주요기능으로 이동
     */
    goFeatures() : void {
        this.doSetFeaturesTab(this.FeaturesTab.CALENDAR);
        this.$router.push('/features').catch(e => {});
    }

    /**
     * 매뉴얼로 이동
     */
    goManual() : void {
        this.doSetManualTab(this.ManualTab.CALENDAR);
        this.$router.push('/manual').catch(e => {});
    }

    /**
     * 호두 공지사항으로 이동
     */
    goNotice() : void {
        this.$router.push('/notice').catch(e => {});
    }

    /**
     * 요금안내 페이지로 이동
     */
    getPayment() : void {
        this.$router.push('/payment').catch(e => {});
    }

    /**
     * 고객센터로 이동
     */
    goServiceCenter() : void {
        this.doSetServiceCenterTab(this.ServiceCenterTab.QNA);
        this.$router.push('/serviceCenter').catch(e => {});
    }

}

